import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type QuizSubmissionDTO = {
  questionId: string;
  choiceId: string;
  marked?:boolean
};
export type QuizResponse = {
  score: number;
  status: string;
  trial: number;
  count_correct: number;
  count_wrong: number;
  count_marked:number;
  correctQuestions: {
    question: string;
    choices: {
      answer:string;
      isCorrect:boolean;
      selected:boolean
    }[]
  }[];
  wrongQuestions: {
    question: string;
    choices: {
      answer:string;
      isCorrect:boolean;
      selected:boolean
    }[]
  }[];
  markedQuestions: {
    question: string;
    choices: {
      answer:string;
      isCorrect:boolean;
      selected:boolean
    }[]
  }[];

} & ApiError;
export const SubmitExamMcq = (
  quizId: string,
  submissions: QuizSubmissionDTO[]
): Promise<QuizResponse> => {
  return axios.post(`/exam/part1Submit/${quizId}`, submissions);
};
